module.exports = __webpack_public_path__ + "static/media/pycharm_small.b05c5492.png";